import { rcConstants } from '../constants'

const initialState = {
  token: 'test',
  errorMessage: null,
  authenticated: false,
}

const rcReducer = (state = initialState, action) => {
  const { response, error } = action
  switch (action.type) {
    // Auth User
    case rcConstants.SAVE_AUTH_USER_SUCCESS:
      return {
        ...state,
        authenticated: true,
        token: response.token,
      }
    case rcConstants.SAVE_AUTH_USER_FAILURE:
      return { ...state, authenticated: false, token: null }
    // Logout
    case rcConstants.REMOVE_AUTH_USER:
      return {
        ...state,
        authenticated: false,
        token: null,
      }
    default:
      return state
  }
}

export default rcReducer
